// removed by extract-text-webpack-plugin
module.exports = {"table":"_-src-components-RuleList-styles---table---1W2_m","ellipsis":"_-src-components-RuleList-styles---ellipsis---1tJ23","cell":"_-src-components-RuleList-styles---cell---2FEmF","title":"_-src-components-RuleList-styles---title---ayT7Z","header":"_-src-components-RuleList-styles---header---2vUC7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RuleList/styles.css
// module id = 808
// module chunks = 0